import { IdDescricao } from '../../../../../models/util/id-descricao';
import { ProcessoAnexo } from '@app/models/processo-anexo.model';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SafeUrl } from '@angular/platform-browser';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

import { TipoMovimentacao, ProcessoMovimentacao } from '@app/models/processo-movimentacao';
import { ProcessoService } from '@app/services/processo.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { UtilitarioService } from '@app/services/utilitario.service';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { SigiloAutorizacao } from '@app/models/sigilo-autorizacao.model';
import { ConsultasService } from '@app/services/consultas.service';
import { CDSMask } from '@app/utils/cds-mask';
import debounce from '@app/utils/debounce';

import { Paginacao } from '@app/models/util/paginacao';
import { Observable, Subscription, combineLatest, forkJoin, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Instancia } from '@app/models/processo.model';
import { MigracaoMovimentacao } from '@app/models/migracao-movimentacao.model';
import { ParticipanteService } from '@app/services/participante.service';

@Component({
  selector: 'app-movimentacao-lista',
  templateUrl: './movimentacao-lista.component.html',
  styleUrls: ['./movimentacao-lista.component.scss']
})
export class MovimentacaoListaComponent implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private processoService: ProcessoService,
    private modalService: BsModalService,
    @Inject(ToastrService) public toastr: ToastrService,

    private utilitarioService: UtilitarioService,
    private usuarioTipoService: UsuarioTipoService,
    private consultasService: ConsultasService,
    private participanteService: ParticipanteService,
    @Inject (DOCUMENT) private document
    ) { }

  processoId: number;
  tipoMovimentacao: TipoMovimentacao;
  titulo: string;
  desativaAposSolicitarArquivo: boolean = false;

  lstProcessoMovimentacao: ProcessoMovimentacao[] = [];
  exibirBtn = false;
  bsModalRef: BsModalRef;

  fileUrl: SafeUrl;

  mostrarHistoricoAlteracoes = false;
  // textoTitulo = '(Visualizar Histórico das Alterações)';
  lstLog: any[];
  loading = true;
  meAviseIdNavegacao;
  tipoVisaoMovimentacoes: string = 'PAGINADA';

  inscricao = new Subscription();
  mostrarMovimentacaoHistorica : boolean = false;

  cdsMask: CDSMask = new CDSMask();
  sigiloAutorizacao: SigiloAutorizacao = new SigiloAutorizacao();
  acessoGerenciarSigilo: boolean = false;
  acessoDesrealizarMeAvise: boolean = false;
  lstParticipante: IdDescricao[] = [];

  lstInstancias: Instancia[];
  lstTipoMovimentacao: IdDescricao[] = [];
  migracaoMovimentacao: MigracaoMovimentacao = new MigracaoMovimentacao();
  mostrarNumerosMigracao: boolean = false;
  mostrarNumeroBeneficio: boolean = false;
  mostrarNumeroInstancia: boolean = false;
  aguardeMigracao: boolean = false;
  podeMigrarMovimentacao: boolean = false;
  podeEditarFixadoMovimentacao: boolean = false;
  podeEditarDestaqueMovimentacao: boolean = false;
  podeEditarResumoMovimentacao: boolean = false;

  _debounce: any;
  _pesquisa: any;

  paginacao: Paginacao = new Paginacao();

  ngOnInit() {
    this.mostrarHistoricoAlteracoes = false;

    this.participanteService.verificaPermissaoUsuario(0, 'MigrarMovimentacoesDoProcesso')
      .subscribe(data => this.podeMigrarMovimentacao = data);

    this.participanteService.verificaPermissaoUsuario(0, 'EditarFixadoMovimentacao')
      .subscribe(data => this.podeEditarFixadoMovimentacao = data);

    this.participanteService.verificaPermissaoUsuario(0, 'EditarDestaqueMovimentacao')
      .subscribe(data => this.podeEditarDestaqueMovimentacao = data);

    this.participanteService.verificaPermissaoUsuario(0, 'EditarResumoMovimentacao')
      .subscribe(data => this.podeEditarResumoMovimentacao = data);

    let tipoMovimentacaoMap : Map<string,object> = new Map();
    tipoMovimentacaoMap.set("ADMINISTRATIVA", {
      tipoMovimentacao : TipoMovimentacao.ADMINISTRATIVA,
      titulo: 'Movimentação Administrativa'
    });
    tipoMovimentacaoMap.set("JUDICIAL", {
      tipoMovimentacao : TipoMovimentacao.JUDICIAL,
      titulo: 'Movimentação Judicial'
    });
    tipoMovimentacaoMap.set("EXECUCAO-PROVISORIA", {
      tipoMovimentacao : TipoMovimentacao.EXECUCAO_PROVISORIA,
      titulo: 'Movimentação Execução Provisória'
    });
    tipoMovimentacaoMap.set("ATO-PROCESSUAL", {
      tipoMovimentacao : TipoMovimentacao.ATO_PROCESSUAL,
      titulo: 'Movimentação Ato processual'
    });
    tipoMovimentacaoMap.set("ADMINISTRATIVA", {
      tipoMovimentacao : TipoMovimentacao.ADMINISTRATIVA,
      titulo: 'Movimentação Administrativa'
    });

    let tipoMovimentacaoObservable = this.route.params;
    let processoIdObservable = this.route.parent.params;
    let meAviseIdObservable = this.route.queryParams;

    //
    
    this.inscricao = combineLatest([tipoMovimentacaoObservable, processoIdObservable, meAviseIdObservable]).subscribe(
      ([resultado1, resultado2, resultado3]) => {
        //primeira
        const tipo: string = resultado1['tipo'].toUpperCase();
        this.tipoMovimentacao = tipoMovimentacaoMap.get(tipo)['tipoMovimentacao'];
        this.titulo = tipoMovimentacaoMap.get(tipo)['titulo'];
        //segunda
        const id: string = resultado2['id'];
        this.processoId = parseInt(id, 10);
        //terceira
        this.meAviseIdNavegacao = resultado3['meAviseId'];
        
        if(this.mostrarMovimentacaoHistorica === false) {
          if (this.meAviseIdNavegacao !== undefined && this.meAviseIdNavegacao !== null) {
            this.tipoVisaoMovimentacoes = 'GERAL';
          } else {
            this.tipoVisaoMovimentacoes = 'PAGINADA';
          }
        }
        
        this.paginacao.paginaAtual = 1;
        this._obterMovimentacao();
      },
      error => {
        console.error(error);
      }
    );

    const data: any = this.route.data;
    if (data.value.exibirBtn) {
      this.exibirBtn = true;
    }

    this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
      (permissoes: any) =>{
        this.acessoGerenciarSigilo = permissoes.find(x => x.Descricao == 'GerenciarSigilo').Selecionado;
        this.acessoDesrealizarMeAvise = permissoes.find(x => x.Descricao == 'DesrealizarMeAviseOutroUsuario').Selecionado;
      }
    );

  }

  private _navegarMeAvise() {
    if(this.meAviseIdNavegacao !== undefined && this.meAviseIdNavegacao !== null) {
      let element;
      setTimeout(() => {
        element = this.document.getElementById(this.meAviseIdNavegacao);
        
        if (element !== null) {
          //element.className += " transition-me-avise";
          element.scrollIntoViewIfNeeded();
        }
      }, 500);
    }
  }

  private _obterMovimentacao() {
    if (this.tipoVisaoMovimentacoes === 'PAGINADA')
      this._obterMovimentacaoPaginada();
    
    if (this.tipoVisaoMovimentacoes === 'GERAL')
      this._obterMovimentacaoGeral();
  }

  ngOnDestroy() {
    this.inscricao.unsubscribe();
  }

  private _obterMovimentacaoPaginada(paginaAtualParametro: number = 0) {
    this.loading = true;
    this.processoService.obterMovimentacaoPaginada(
      this.tipoMovimentacao,
      this.processoId,
      20,
      paginaAtualParametro === 0
        ? this.paginacao.paginaAtual
        : paginaAtualParametro
      ).subscribe(
        (data:{Dados: ProcessoMovimentacao[],TotalMovimentacoes: number}) => {
          this.lstProcessoMovimentacao = data.Dados;
          this._desativaBotaoCadastrar();
          this.paginacao.totalDeItens = data.TotalMovimentacoes;
          if(this.paginacao.paginaAtual === 1) {
            this.paginacao.itensPorPagina = this.lstProcessoMovimentacao.length; // está dessa forma devido as movimentações fixas, pois irá aparecer fixas.length + 15
          }
          this.loading = false;
        },
        erro => this.loading = false
      );
  }

  private _obterMovimentacaoGeral() {
    this.loading = true;
    this.processoService.obterMovimentacaoGeral(this.tipoMovimentacao, this.processoId)
      .subscribe(
        data => {
          this.lstProcessoMovimentacao = data;
          this._desativaBotaoCadastrar();
          this.loading = false;
          this._navegarMeAvise();
          //this._navegarMeAvise2();
        },
        erro => this.loading = false
      );
  }

  private _desativaBotaoCadastrar() {
    const movimentacaoProcessoArquivado = this.lstProcessoMovimentacao.find(x => x.ProcessoArquivado === true);
    if (movimentacaoProcessoArquivado !== undefined)
      this.exibirBtn = false;
  }

  // private _navegarMeAviseBackup() {
  //   let inscricao;
  //   inscricao = this.route.queryParams.subscribe(
  //     queryParams => {
  //       let meAviseId = queryParams.meAviseId;

  //       if(meAviseId !== undefined && meAviseId !== null) {
  //         let element;
  //         setTimeout(() => {
  //           element = this.document.getElementById(meAviseId);
            
  //           if (element !== null) {
  //             element.className += " transition-me-avise";
  //             element.scrollIntoViewIfNeeded();
  //           }
  //         }, 500);
  //       }
  //     },
  //     error => console.error(error),
  //     () => inscricao.unsubscribe() 
  //   );
  // }

  obterHistoricoMovimentacoes() {
    this.processoService.obterMovimentacaoHistorico(this.tipoMovimentacao, this.processoId)
      .toPromise().then(data => {
        this.lstLog = data;
      });
  }

  trocaPagina(evento: any) {
    // cuidado, tem dois componentes "pagination", um deles possui o evento de troca de página, mas se colocar nos dois, a chamada fica duplicada pois estão associados sendo que um deve ser apenas espelho
    this._obterMovimentacaoPaginada(evento.page);
  }

  deletar(processoMovimentacao: ProcessoMovimentacao) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente deletar a movimentação? <br> Todos os vínculos (me avise, prazo, agendamento e anexo) serão deletados.';
    this.bsModalRef.content.confirmar = async () => {
      this.processoService.deletarMovimentacao(processoMovimentacao.Id).toPromise().then(
        () => {
          this.toastr.success('Movimentação deletada com sucesso!');
          this.lstProcessoMovimentacao = this.lstProcessoMovimentacao.filter(x => x.Id !== processoMovimentacao.Id);
        },
        data => this.toastr.error(data.error.errors[0])
      );
    }
  }

  fixar(processoMovimentacao: ProcessoMovimentacao) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente Fixar a movimentação?';
    this.bsModalRef.content.confirmar = async () => {
      this.processoService.fixarOuDesafixarMovimentacao(processoMovimentacao.Id).toPromise().then(
        () => {
          this._obterMovimentacao()
          this.toastr.success('Movimentação Fixada com sucesso!');
          this.lstProcessoMovimentacao = this.lstProcessoMovimentacao.filter(x => x.Id !== processoMovimentacao.Id);
        },
        data => this.toastr.error(data.error.errors[0])
      );
    }
  }

  desafixar(processoMovimentacao: ProcessoMovimentacao) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente Desafixar a movimentação?';
    this.bsModalRef.content.confirmar = async () => {
      this.processoService.fixarOuDesafixarMovimentacao(processoMovimentacao.Id).toPromise().then(
        () => {
          this._obterMovimentacao();
          this.toastr.success('Movimentação Desafixada com sucesso!');
          this.lstProcessoMovimentacao = this.lstProcessoMovimentacao.filter(x => x.Id !== processoMovimentacao.Id);
        },
        data => this.toastr.error(data.error.errors[0])
      );
    }
  }

  destacar(processoMovimentacao: ProcessoMovimentacao) {
    
    

    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente Destacar a movimentação?';
    this.bsModalRef.content.confirmar = async () => {
      this.processoService.destacarOuTirarDestaqueMovimentacao(processoMovimentacao.Id).toPromise().then(
        () => {
          this._obterMovimentacao()
          this.toastr.success('Movimentação Destacada com sucesso!');
          this.lstProcessoMovimentacao = this.lstProcessoMovimentacao.filter(x => x.Id !== processoMovimentacao.Id);
        },
        data => this.toastr.error(data.error.errors[0])
      );
    }
  }

  retirarDestaque(processoMovimentacao: ProcessoMovimentacao) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente retirar Destaque da movimentação?';
    this.bsModalRef.content.confirmar = async () => {
      this.processoService.destacarOuTirarDestaqueMovimentacao(processoMovimentacao.Id).toPromise().then(
        () => {
          this._obterMovimentacao()
          this.toastr.success('Destaque retirado da movimentação com sucesso!');
          this.lstProcessoMovimentacao = this.lstProcessoMovimentacao.filter(x => x.Id !== processoMovimentacao.Id);
        },
        data => this.toastr.error(data.error.errors[0])
      );
    }
  }

  resumir(processoMovimentacao: ProcessoMovimentacao) {
    

    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente Resumir a movimentação?';
    this.bsModalRef.content.confirmar = async () => {
      this.processoService.resumoOuTirarResumoMovimentacao(processoMovimentacao.Id).toPromise().then(
        () => {
          this._obterMovimentacao()
          this.toastr.success('Movimentação Resumida com sucesso!');
          this.lstProcessoMovimentacao = this.lstProcessoMovimentacao.filter(x => x.Id !== processoMovimentacao.Id);
        },
        data => this.toastr.error(data.error.errors[0])
      );
    }
  }

  retirarResumo(processoMovimentacao: ProcessoMovimentacao) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente retirar Resumo da movimentação?';
    this.bsModalRef.content.confirmar = async () => {
      this.processoService.resumoOuTirarResumoMovimentacao(processoMovimentacao.Id).toPromise().then(
        () => {
          this._obterMovimentacao()
          this.toastr.success('Resumo retirado da movimentação com sucesso!');
          this.lstProcessoMovimentacao = this.lstProcessoMovimentacao.filter(x => x.Id !== processoMovimentacao.Id);
        },
        data => this.toastr.error(data.error.errors[0])
      );
    }
  }

  realizar(prazoId: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente marcar como realizado?';
    this.bsModalRef.content.confirmar = () => {
      this.processoService.realizarMeAvisePrazo(prazoId).toPromise().then(
        () => this._obterMovimentacao(),
        //this.obterMovimentacao(),
        data => this.toastr.error(data.errors[0]));
    };
  }

  desrealizarMeAvise(meAviseId: number){
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente desrealizar o Me Avise?';
    this.bsModalRef.content.confirmar = () => {
      this.processoService.desrealizarMeAvisePrazo(meAviseId).subscribe(
        () => this._obterMovimentacao(),
      erro => this.toastr.error(erro.errors[0]));
    }
  }

  abrirMeAviseRealizado(index) {
    this.lstProcessoMovimentacao.forEach(item => {
      if (item.Id == index) {
        item.Aberto = !item.Aberto
      }
    })
  }

  navigateTo(location: string): void {
    document.getElementById(location).parentElement.scrollIntoView();
  }

  deletarArquivo(movimentacao: ProcessoMovimentacao, anexoId, index) {

    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir o anexo?';
    this.bsModalRef.content.confirmar = () => {
      this.document.getElementById('overlay').style.display = 'block';
      this.processoService.movimentacaoDeletarArquivo(anexoId).pipe(
        finalize(() => {
          this.document.getElementById('overlay').style.display = 'none';
        })
      ).subscribe(
        () => {
          movimentacao.Anexo.splice(index, 1);
          this.toastr.success('Anexo exluído com sucesso!');
        },
        data => this.toastr.error(data.errors[0])
      );
    };
  }

  public obterArquivo(id: number, nome: string) {
    this.processoService.movimentacaoObterArquivo(id).subscribe((data) => {
      this.utilitarioService.saveAs(data, nome);
    });
  }

  obterSasRealizandoDownloadAnexoMovimentacao(anexo: ProcessoAnexo, advogadoDoProcesso: boolean) {
    this.desativaAposSolicitarArquivo = true;
    if(anexo.Sigiloso && !anexo.PermissaoAcessarSigilo && !advogadoDoProcesso && !this.acessoGerenciarSigilo){
      this.toastr.error('Anexo sigiloso, solicite acesso ao seu gestor!');
      return;
    }

    this.processoService.obterSasUrlParaDownloadMovimentacaoAnexo(anexo.Id).subscribe((uriString) => {
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.href = uriString;
      a.protocol = "https";
      a.click();
      a.remove();
    }, (erro) => {
      this.toastr.error("Arquivo não encontrado");
      this.desativaAposSolicitarArquivo = false;
    }, () => {
      this.desativaAposSolicitarArquivo = false;
    });
  }

  getPendentes(meAvise: any) {
    if (!meAvise) {
      return [];
    }
    const pendentes: any[] = [];

    for (let i = 0; i < meAvise.length; i++) {
      if (!meAvise[i].RealizadoData && !meAvise[i].RealizadoUsuario) {
        pendentes.push(meAvise[i]);
      }
    }
    return pendentes;
  }

  getRealizados(meAvise: any) {
    if (!meAvise) {
      return [];
    }
    const realizados: any[] = [];

    for (let i = 0; i < meAvise.length; i++) {
      if (meAvise[i].RealizadoData || meAvise[i].RealizadoUsuario) {
        realizados.push(meAvise[i]);
      }
    }
    return realizados;
  }

  clickHistorico() {
    this.mostrarHistoricoAlteracoes = !this.mostrarHistoricoAlteracoes;
    if(this.mostrarHistoricoAlteracoes){
      this.obterHistoricoMovimentacoes();
    }
    //this.textoTitulo = this.mostrarHistoricoAlteracoes ? '- Histórico Alterações' : '+ Histórico Alterações';
  }

  clickTodasMovimentacoes() {
    if(this.mostrarMovimentacaoHistorica === false) {
      this.tipoVisaoMovimentacoes = 'GERAL'
      this._obterMovimentacao();
    }
    this.mostrarMovimentacaoHistorica = true;
  }

  public ngxselect_typed(value: any): void {
    this._pesquisa = value;
    if (!this._debounce) {
      this._debounce = debounce(() => {
        this.consultasService.consultar('USUARIO', this._pesquisa).toPromise().then(data => {
          this.lstParticipante = data;
        });
      }, 500);
    }
    this._debounce();
  }

  abrirModalMigracao(template: TemplateRef<any>, movimentacaoId: number){
    this.migracaoMovimentacao = new MigracaoMovimentacao(movimentacaoId);
    this.mostrarNumerosMigracao = false;

    this.processoService.ObterInstancias(this.processoId).subscribe(data => this.lstInstancias = data);
    this.preencheListaTipoMovimentacao();
    this.bsModalRef = this.modalService.show(template);
  }

  tratamentoSelectTipoMovimentacao(){
    this.mostrarNumerosMigracao = true;

    this.mostrarNumeroBeneficio = false;
    this.mostrarNumeroInstancia = false;

    if(this.migracaoMovimentacao.TipoMovimentacaoMigrarId === 1)
      this.mostrarNumeroBeneficio = true;
    else
      this.mostrarNumeroInstancia = true;
    
  }

  gravarMigracao(){
    if(!this.migracaoMovimentacao.TipoMovimentacaoMigrarId){
      this.toastr.error('Obrigatório selecionar tipo de movimentação!');
      return;
    }

    this.aguardeMigracao = true;
    this.processoService.migrarMovimentacao(this.migracaoMovimentacao).subscribe(() => {
      this.fecharModal();
      this.toastr.success('Movimentação migrada com sucesso!');
      this._obterMovimentacao();
      this.aguardeMigracao = false;
    },
    (error: any) => {
      this.toastr.error(error.error.errors[0]);
      this.aguardeMigracao = false;
    });
  }

  preencheListaTipoMovimentacao(){
    this.lstTipoMovimentacao[0] = new IdDescricao(1, "ADMINISTRATIVA");
    this.lstTipoMovimentacao[1] = new IdDescricao(2, "EXECUÇÃO PROVISÓRIA");
    this.lstTipoMovimentacao[2] = new IdDescricao(3, "JUDICIAL");

    this.lstTipoMovimentacao = this.lstTipoMovimentacao.filter(x => x.Id !== this.tipoMovimentacao);
  }

  abrirLiberarAcessoModal(template: TemplateRef<any>, tipo: string, idSigiloso: number){
    if(tipo === 'MOVIMENTACAO'){
      this.sigiloAutorizacao.MovimentacaoId = idSigiloso;
    }

    if(tipo === 'ANEXO'){
      this.sigiloAutorizacao.AnexoId = idSigiloso;
    }

    this.bsModalRef = this.modalService.show(template);
  }

  fecharModal(){
    this.bsModalRef.hide();
  }

  liberarAcesso(){
    if(!this.sigiloAutorizacao.UsuarioPermitidoId){
      this.toastr.warning('Favor selecionar usuário!');
      return;
    }
    if(!this.sigiloAutorizacao.DataPermitida){
      this.toastr.warning('Favor selecionar data!');
      return;
    }

    this.processoService.liberarAcessoSigilo(this.sigiloAutorizacao).subscribe(() => {
      this.toastr.success('Usuário liberado!');
      this.fecharModal();
    },
    (data) => {
      this.toastr.error(data.error.errors[0]);
      this.fecharModal();
    });
  }

  aplicarSigiloMovimentacao(movId: number){
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = `Deseja realmente aplicar sigilo nessa movimentação?
    Ela ficará visível apenas para: Advogados do processo, usuários com permissão no Perfil ou liberação temporária.`;
    this.bsModalRef.content.confirmar = () => {
      this.processoService.aplicarSigiloMovimentacao(movId).subscribe(() => {
        this.toastr.success('Sigilo aplicado com sucesso!');
        this._obterMovimentacao();
      },
      (data) => {
        this.toastr.error(data.error.errors[0]);
      });
    };
  }

  desativarSigiloMovimentacao(movId: number){
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = `Deseja realmente remover o sigilo da movimentação?
    Ela ficará visível para todos os usuários.`;
    this.bsModalRef.content.confirmar = () => {
      this.processoService.desativarSigiloMovimentacao(movId).subscribe(() => {
        this.toastr.success('Sigilo removido com sucesso!');
        this._obterMovimentacao();
      },
      (data) => {
        this.toastr.error(data.error.errors[0]);
      });
    };
    
  }

  aplicarSigiloAnexo(anexoId: number){
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = `Deseja realmente aplicar sigilo nesse anexo?
    Ela poderá ser baixado apenas por: Advogados do processo, usuários com permissão no Perfil ou liberação temporária.`;
    this.bsModalRef.content.confirmar = () => {
      this.processoService.aplicarSigiloAnexo(anexoId).subscribe(() => {
        this.toastr.success('Sigilo aplicado com sucesso!');
        this._obterMovimentacao();
      },
      (data) => {
        this.toastr.error(data.error.errors[0]);
      });
    };
  }

  desativarSigiloAnexo(anexoId: number){
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = `Deseja realmente remover o sigilo do anexo?
    Ele poderá ser baixado por todos os usuários.`;
    this.bsModalRef.content.confirmar = () => {
       this.processoService.desativarSigiloAnexo(anexoId).subscribe(() => {
        this.toastr.success('Sigilo removido com sucesso!');
        this._obterMovimentacao();
        // this.obterMovimentacao();
      },
      (data) => {
        this.toastr.error(data.error.errors[0]);
      });
    };
  }

}



